import React from "react";
import Officialfaq from "./components/Officialfaq";
import './App.css';

function About() {

     return (
       <div> 
         <center>
           <p class="font-weight-bold text-white p-2 rounded border border-white shadow-lg ml-5 mr-5 mt-5 mb-3 bg-primary"><h5>About Swastha Sebok [ Data Accurracy -- T&Cs -- Full Detail ]</h5></p>
           
         </center>
       </div>
     );

 }

 export default About;